// Dependencies
require("webstrap/scaffolding");

// Styles
require("./type.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/type/index.js
 ** module id = 59
 ** module chunks = 0 1
 **/